import { render, staticRenderFns } from "./BlackListPop.vue?vue&type=template&id=57de8f7b&"
import script from "./BlackListPop.vue?vue&type=script&lang=js&"
export * from "./BlackListPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports